import {Flex, Image} from "antd";
import {Fade} from "react-awesome-reveal";
import img25 from "../../About/images/25.jpg";
import MyText from "../../../components/UI/Text/MyText";
import {clrs} from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import {Link} from "react-router-dom";
import {LinkOutlined} from "@ant-design/icons";
import React from "react";

export const Person25 = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img25} width={300} preview={false} style={{ borderRadius: 20 }} />
                </Fade>

                <Flex style={{ width: "100%", position: "relative" }} vertical>
                    <MyText strong size={"large"}>
                        Микряков Андрей Денисович
                    </MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Bachelor of Industrial Automation, Master student of Computer Science and Engineering.
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={20} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://orcid.org/0009-0004-3827-5832'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>
                        Основное место работы, должность
                    </MyText>
                    <MyText>
                        ТОО "Astana IT University", разработчик встраиваемых систем, НИЦ "Industry 4.0".<br />
                        <b>Стаж по профилю – 2 года.</b>
                    </MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте или программе, а также характер выполняемой работы</MyText>
                <MyText size={"small"} italic>
                    Совместное проведение экспериментальных исследований;<br />
                    Разработка встраиваемых систем и IoT-устройств;<br />
                    Интеграция различных датчиков и модулей связи (LoRa, GSM, Wi-Fi);<br />
                    Тестирование, отладка и запуск метеостанций в полевых условиях.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Студент магистратуры по специальности «Computer Science and Engineering». Выпускник бакалавриата по промышленной автоматизации. Активно участвует в разработке интеллектуальных решений для экологического и сельскохозяйственного мониторинга. Обладает опытом в области встраиваемых систем, прототипирования, беспроводной связи, микроконтроллеров, облачной архитектуры и 3D-моделирования. Практические знания в COMSOL, MatLab, AutoCAD, а также уверенные навыки в электронике, электротехнике и математическом моделировании.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные Проекты, в которых принимал участие:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Участвует в проекте программно-целевого финансирования на 2023-2025 гг. ИРН BR21882258 «Разработка комплекса интеллектуальных информационно-коммуникационных систем для экологического мониторинга эмиссий в окружающую среду для принятия решения в концепте углеродной нейтральности». <i>Роль – исполнитель.</i>
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Участвует в проекте программно-целевого финансирования на 2024-2026 гг. ИРН BR24993128 «Разработка информационно-аналитической системы для принятия решений, обеспечивая эффективное использование трансграничных водных ресурсов в сельскохозяйственной отрасли Жамбылского региона». <i>Роль – исполнитель.</i>
                </MyText>
            </Flex>
        </Flex>
    );
}